import { Navigate } from "react-router";
import { useAuth } from "@features/auth";

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
	const { user, loading } = useAuth();

	if (loading) {
		return (
			<div className="flex h-screen items-center justify-center">
				<div className="size-16 animate-spin rounded-full border-4 border-solid border-primary border-t-transparent"></div>
			</div>
		);
	}

	if (!user) {
		return <Navigate to="/signin" replace />;
	}

	return <>{children}</>;
}
